import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  fill: "none",
  viewBox: "0 0 18 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#000",
      d: "M8.963 13.5q.393 0 .666-.272a.9.9 0 0 0 .271-.665.9.9 0 0 0-.271-.667.9.9 0 0 0-.666-.271.9.9 0 0 0-.666.272.9.9 0 0 0-.272.665q0 .394.272.667a.9.9 0 0 0 .665.271m.037 3a7.3 7.3 0 0 1-2.925-.591 7.6 7.6 0 0 1-2.381-1.603 7.6 7.6 0 0 1-1.603-2.381A7.3 7.3 0 0 1 1.5 9a7.3 7.3 0 0 1 .591-2.925 7.6 7.6 0 0 1 1.603-2.381A7.6 7.6 0 0 1 6.075 2.09 7.3 7.3 0 0 1 9 1.5a7.3 7.3 0 0 1 2.925.591 7.6 7.6 0 0 1 2.381 1.603 7.6 7.6 0 0 1 1.604 2.381A7.3 7.3 0 0 1 16.5 9a7.3 7.3 0 0 1-.591 2.925 7.6 7.6 0 0 1-1.603 2.381 7.6 7.6 0 0 1-2.381 1.604A7.3 7.3 0 0 1 9 16.5M9 15q2.513 0 4.256-1.744T15 9t-1.744-4.256Q11.513 3 9 3T4.744 4.744 3 9t1.744 4.256Q6.487 15 9 15m.075-9.225q.47 0 .816.3.348.3.347.75 0 .413-.253.731-.254.32-.572.6-.432.375-.76.825-.327.45-.328 1.013 0 .263.197.44a.66.66 0 0 0 .46.179.67.67 0 0 0 .478-.188.86.86 0 0 0 .252-.469q.075-.393.338-.703a7 7 0 0 1 .563-.59 4.8 4.8 0 0 0 .74-.9 2 2 0 0 0 .31-1.088q0-.957-.779-1.565a2.86 2.86 0 0 0-1.809-.61q-.713 0-1.359.3-.647.3-.985.919a.68.68 0 0 0-.085.478.55.55 0 0 0 .254.384q.262.15.544.094a.75.75 0 0 0 .468-.319q.207-.28.516-.431t.647-.15",
      opacity: ".64"
    }, null, -1)
  ]))]))
}
export default { render: render }